module.exports = __webpack_public_path__ + "img/three1Blue.0596ab3b.jpg";